/**
 * ProHabbo
 *
 * Henrique Arthur <eu@henriquearthur.com.br>
 */

 Emojis = {
    receiver: false,
    insert: function() {
        var id = $(this).data('emoji-id');
        var receiver = Emojis.receiver;

        var currentVal = $(receiver).val();
        var newVal = currentVal + '[e:'+id+']';

        $(receiver).val(newVal);
    },
    open: function() {
        var offset = $(this).offset();
        var height = $(this).height();

        var top = (offset.top + height) + 7 + 12;
        var left = offset.left;

        var box = $("#emojis-box");

        if (box.css('display') == 'none') {
            Emojis.receiver = $(this).data('receiver');

            box.css({
                'top': top + 'px',
                'left': left + 'px'
            }).fadeIn();
        } else {
            Emojis.receiver = false;

            box.fadeOut();
        }
    },
    init: function() {
        $(document).on('click', '.emojis-open', Emojis.open);
        $(document).on('click', '.emoji-inside-box', Emojis.insert);
    }
};

$(document).ready(function() {
    Emojis.init();
});
